import React, { useEffect, useState } from "react";
import "./App.css";
import Login from "./components/Login";
import firebase from "./firebase";
import Home from "./components/Home";
import AdminHome from "./components/Admin/AdminHome";
import Loader from "react-spinners/ClipLoader";
import Feedback from "./components/feedback";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function App() {
  const [loading, setLoading] = useState(true);
  const [sec, setSec] = useState({
    email: "",
    photoURL: "",
    sec: "",
  });
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setSec({
          name: user.name,
          email: user.email,
          photoURL: user.photoURL,
          sec: user.uid,
        });
      }
      setLoading(false);
    });
  }, []);
  if (sec.sec) {
    if (sec.email === "sskundugmn@gmail.com") {
      return <AdminHome setSec={setSec} />;
    }
    return <Home sec={sec} setSec={setSec} />;
  }
  return (
    <Router>
      <Switch>
        <Route exact path="feedback">
          <Feedback />
        </Route>
        <Route>
          <div className="app">
            {loading ? (
              <div style={{ textAlign: "center" }}>
                <h1>Loading</h1>
                <Loader loading={loading} color={`#4285f4`} size={150} />{" "}
              </div>
            ) : (
              <Login />
            )}
          </div>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
